export interface INameToId {
  name: string;
  id: number;
}

export interface ICreateOrUpdateCatsResponse {
  cats: INameToId[];
}

export enum AbandonedCartFailureReason {
  USER_NOT_FOUND = "USER_NOT_FOUND",
  HAS_ALREADY_BEEN_CHARGED = "HAS_ALREADY_BEEN_CHARGED",
  HAS_CONFLICTING_PERMISSIONS = "HAS_CONFLICTING_PERMISSIONS",
  AC_INTERNAL_ERROR = "AC_INTERNAL_ERROR",
  CAT_DETAILS_CREATE_FAILED = "CAT_DETAILS_CREATE_FAILED",
  CAT_DETAILS_UPDATE_FAILED = "CAT_DETAILS_UPDATE_FAILED",
  OLD_DB_SYNC_FAILED = "OLD_DB_SYNC_FAILED",
  CUSTOMER_SUF_ANSWERS_EVENT_FAILED = "CUSTOMER_SUF_ANSWERS_EVENT_FAILED",
  CAT_SUF_ANSWERS_UPDATE_FAILED = "CAT_SUF_ANSWERS_UPDATE_FAILED",
  CAT_TO_BREEDER_UPDATE_FAILED = "CAT_TO_BREEDER_UPDATE_FAILED",
  CAT_SUF_ANSWERS_CREATE_FAILED = "CAT_SUF_ANSWERS_CREATE_FAILED",
  CAT_TO_BREEDER_CREATE_FAILED = "CAT_TO_BREEDER_CREATE_FAILED",
}

export interface ICreateOrUpdateCatsUnprocessableEntityResponse {
  reason: AbandonedCartFailureReason;
}
